const productGrid = document.querySelector(".product-grid-wrapper");
const filterToggleBtn = document.querySelector(".filter-toggle-btn");
const displayFilterClose = document.querySelector(".display-filter_icon");
const filterSidebar = document.querySelector(".filter-sidebar");
const filterContent = document.querySelector(".filter-content");
const closeFilterBtn = document.querySelector(".close-filter");
const filterForm = document.getElementById("filter-form");
let isLoading = false;

function loadPage(url) {
  if (isLoading) return;
  isLoading = true;
  productGrid.classList.add("loading");

  fetch(url)
    .then((response) => response.text())
    .then((html) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const newProducts = doc.querySelector(".product-grid-wrapper").innerHTML;
      const newPagination = doc.querySelector(".pagination")?.outerHTML || "";

      setTimeout(() => {
        productGrid.innerHTML = newProducts;
        const paginationContainer = document.querySelector(".pagination");
        if (paginationContainer) {
          paginationContainer.outerHTML = newPagination;
        } else if (newPagination) {
          productGrid.insertAdjacentHTML("afterend", newPagination);
        }

        addPaginationListeners();
        addFilterListeners(); // Asegurarse de que los nuevos filtros tengan listeners
        isLoading = false;
        productGrid.classList.remove("loading");
      }, 200);
    })
    .catch((error) => {
      console.error("Error loading page:", error);
      isLoading = false;
      productGrid.classList.remove("loading");
    });
}

function clearAllFilters(e) {
  if (e) e.preventDefault();

  const activeFilters = document.querySelectorAll(".filter-checkbox:checked");
  activeFilters.forEach((checkbox) => {
    checkbox.checked = false;
  });

  const url = window.location.pathname;
  history.pushState({ path: url }, "", url);
  loadPage(url);
}

function addPaginationListeners() {
  const paginationLinks = document.querySelectorAll(".pagination a");
  paginationLinks.forEach((link) => {
    link.addEventListener("click", function (e) {
      e.preventDefault();
      const url = this.href;
      history.pushState({ path: url }, "", url);
      loadPage(url);
    });
  });
}

function addFilterListeners() {
  const filterCheckboxes = document.querySelectorAll(".filter-checkbox");
  filterCheckboxes.forEach(function (checkbox) {
    checkbox.removeEventListener("change", handleFilterChange);
    checkbox.addEventListener("change", handleFilterChange);
  });
}

function handleFilterChange() {
  applyFilters();
}

function applyFilters() {
  const formData = new FormData(filterForm);
  const searchParams = new URLSearchParams(formData);
  const url = `${window.location.pathname}?${searchParams.toString()}`;
  history.pushState({ path: url }, "", url);
  loadPage(url);
}

// Event Listeners
if (filterToggleBtn) {
  filterToggleBtn.addEventListener("click", () => {
    filterContent.style.display = "block";
  });
}

if (closeFilterBtn) {
  closeFilterBtn.addEventListener("click", () => {
    filterContent.style.display = "none";
  });
}

if (displayFilterClose) {
  displayFilterClose.addEventListener("click", () => {
    const currentDisplay = window.getComputedStyle(filterSidebar).display;
    if (currentDisplay === "block") {
      filterSidebar.style.display = "none";
      productGrid.classList.add("sidebar-hidden");
    } else {
      filterSidebar.style.display = "block";
      productGrid.classList.remove("sidebar-hidden");
    }
  });
}

// Inicialización
addPaginationListeners();
addFilterListeners();

window.addEventListener("popstate", function (e) {
  if (e.state && e.state.path) {
    loadPage(e.state.path);
  }
});

history.replaceState({ path: window.location.href }, "");
